import React, { useEffect, useState } from 'react'
import { Container } from './styled'
import { createBooking,  getCommunities, getVenuesGroup, getVenuePrice} from 'api'
import { TextField, Select, Grid, MenuItem, Button } from '@mui/material'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const BookingForm = () => {
  const [bookingPrice, setBookingPrice] = useState("")
  const [description, setDescription] = useState("")
  const [communities, setCommunities] = useState([]);
  const [venues, setVenues] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [prices, setPrices] = useState([])

  const [theBooking, setBooking] = useState({
    slug: '',
    name: '',
    description: '',
    community: '',
    space: '',
    tags: [],
    date: null,
    start: null,
    end: null,
    spaces: 0,
    image: '',
    background: '',
  })

  function addBooking() {
    if (!theBooking.space) return
    if (!theBooking.date) return
    if (theBooking.spaces <= 0) return
    if (!prices || prices.length === 0) return

    const formattedDate = theBooking.date.format('YYYY-MM-DD');
    const formData = {
      "bookings": [
        {
          venue: theBooking.space,
          start: formattedDate,
          end: formattedDate,
          number_spaces: theBooking.spaces,
          booking_type: 'HD',
          price: prices[0].price,
        }
      ]
    }
    createBooking(formData)
  }

  const handleCommunity = (booking) => {
    setBooking({ ...theBooking, community: booking.target.value })
  };

  const handleSpace = (booking) => {
    setBooking({ ...theBooking, space: booking.target.value })
  };

  const handleDateChange = (date) => {
    setBooking({ ...theBooking, date: date })
    setSelectedDate(date);
  };

  function getVenuePricesInfo() {
    const parameters = {
      spaces: theBooking.spaces,
      // format theBooking.date  as YYYY-MM-DD
      start: theBooking?.date?.format('YYYY-MM-DD'),
      end: theBooking.date.format('YYYY-MM-DD'),
      booking_type : 'HD'
    }

    getVenuePrice(theBooking.space, parameters).then(r => {
      setPrices(r.prices)
      // get the element title from the first element of the array prices
      r.prices.length > 0 && setBookingPrice(r.prices[0].title ? r.prices[0].title : '')
    })
      .catch(console.error)
  }

  useEffect(() => {
    getCommunities().then(r => {
      setCommunities(r.communities)
    }).catch(console.error)
  }, [])

  useEffect(() => {
    if (theBooking.community !== '') {
      getVenuesGroup(theBooking.community).then(r => {
        setVenues(r.venues)
      }).catch(console.error)
    }
  }, [theBooking.community])

  useEffect(() => {
    if (theBooking.date !== null && theBooking.space !== '' && theBooking.spaces > 0) {
      getVenuePricesInfo(true)
    }
  }, [theBooking])

  return (
    <Container>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
      }}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <TextField
              label="Spaces"
              type="number"
              value={theBooking.spaces}
              onChange={(e) => setBooking({ ...theBooking, spaces: e.target.value })}
              InputProps={{
                inputProps: {
                  min: 0,
                  step: 1,
                },
              }}
            />

          </Grid>
          <Grid item xs={12} sm={12}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker label="Booking date" value={selectedDate} onChange={handleDateChange} />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Select
              value={theBooking?.community}
              onChange={handleCommunity}
              displayEmpty
              inputProps={{ 'aria-label': 'Community' }}
            >
              <MenuItem value="" disabled>Select a community</MenuItem>
              {communities?.map((item, index) => (
                <MenuItem key={index} value={item.slug}>{item.name}</MenuItem>
              ))
              }
              {/* Add more communities as needed */}
            </Select>
          </Grid>
          <Grid item xs={12} sm={12}>
            <Select
              value={theBooking?.space}
              onChange={handleSpace}
              displayEmpty
              inputProps={{ 'aria-label': 'Community' }}
            >
              <MenuItem value="" disabled>Select a venue</MenuItem>
              {venues?.map((item, index) => (
                <MenuItem key={index} value={item.slug}>{item.name}</MenuItem>
              ))}
            </Select>
          </Grid>          
          <Grid item xs={12} sm={12}>
            <TextField label="Comments" value={description} onChange={(e) => setDescription(e.target.value)} style={{ width: '60%' }} />
          </Grid>

          
          <Grid item xs={12} sm={12}>
            <Button variant="extended" color="primary" aria-label="add" style={{ width: '60%' }} onClick={() => addBooking()}>
              Book for {bookingPrice}
            </Button>
          </Grid>
        </Grid>
      </div>
    </Container>
  )
}

BookingForm.propTypes = {}

export default BookingForm
